import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  InventoryItemPage,
  inventoryItemQueryOptions,
  stockLocationsQueryOptions,
} from '@/features/inventory';

export const Route = createFileRoute('/_authed/_active/s/$storeId/inventory_/$variantId')({
  staticData: { crumb: 'common:nav.inventory' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'inventory.read');
  },
  loader: async ({ context, params }) => {
    const [item] = await Promise.all([
      context.queryClient
        .query({
          ...inventoryItemQueryOptions(params.storeId, params.variantId),
          staleTime: 'static',
        })
        .catch(() => undefined),
      context.queryClient
        .query({ ...stockLocationsQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return item ? { crumb: `${item.productTitle} · ${item.variantTitle}` } : {};
  },
  component: InventoryItemPage,
});
